export default {
  招商招标系统: 'Investor Inviting & Tendering',
  个人: 'Personal User',
  注册账户: 'Register an Account',
  '(金币)': '(Gold Coins)',
  '总金额(金币)': 'Total Amount (Gold Coins)',
  '充值金额(金币)': 'Top-up Amount (Gold Coins)',
  '收入金额(金币)': 'Income (Gold Coins)',
  已为您匹配潜在采购商: 'We have found your potential buyers.',
  云招标管理: 'Tender Management',
  云供应管理: 'Supply Management',
  云招商管理: 'Investor Invitation Management',
  '(敬请期待)': '(Coming soon)',
  采购系统: 'Purchasing System',
  我的客户数据: 'My Client Data',
  获客工具: 'Client Access Tool',
  '云优惠(发券)': 'Discount (Coupon)',
  '我的优惠券（领取）': 'My Coupon (Collect) ',
  账号设置: 'Account Setting',
  '立即申请企业认证,获取更多企业服务':
    'Apply for enterprise certification immediately to obtain more enterprise services.',
  '个人用户不支持添加到通讯录,请申请企业认证再操作！':
    'Personal user cannot add to the address book, please apply for enterprise certification first.',
  去申请企业认证: 'Apply for enterprise certification',
  '个人用户无法查阅招标信息,请申请成为企业用户!':
    'Personal user cannot access the tender information, please apply to become enterprise users!',
  '您当前为[基础版],聊天记录最多可保存30天,若保存更长时间,请升级企业会员套餐！':
    'You are currently in the "Starter Edition”, the chat record can be saved up to 30 days. If you want to save longer, please upgrade to the enterprise VIP package!',
  去升级: 'Go to upgrade',
  去升级企业会员套餐: 'Upgrade to enterprise VIP package',
  '云展动力平台提供洽谈消息未读短信提醒功能,客户咨询永不落空,快速响应客户咨询需求,您当前为[基础版],若想使用可升级企业会员套餐 ':
    'Could Exhibition platform provides unread SMS reminders that allow you to reply your clients in time. You are currently [Starter Edition], please upgrade to enterprise VIP package if you want to use this function. ',
  '云展动力平台提供洽谈消息未读短信提醒功能,客户咨询永不落空,快速响应客户咨询需求,您当前为个人用户,请立即申请企业认证 ':
    'Could Exhibition platform provides unread SMS reminders that allow you to reply to your clients in time. You are currently an personal user, please apply for enterprise certification.',
  '您当前的身份为个人用户,请升级成为企业用户,再报名参展!':
    'You are currently an personal user, please upgrade to an enterprise user before registering for the exhibition.',
  '恭喜您注册成功,在云展动力平台您可以免费搜索到全球各地热门供应商。若您是企业用户,还可利用平台的企业云展系统、大数据获客系统、云上展会系统等实现精准获客,促进企业发展.':
    'Registration success! You can search the worldwide excellent suppliers free of charge on the Could Exhibition platform. If you are an enterprise user, you will have access to our features like company page system, big data client access tool and virtual exhibition system to gain more clients accurately.',
  '有效期至 YYYY-MM-nn': 'Date of Expiry: YYYY-MM-nn',
  '客户详情查看仅开通企业会员套餐的用户使用,请开通企业会员套餐再查看！':
    'The view of client details is only available to enterprise VIP package users. Please check it after opening the enterprise VIP package.',
  '员工详情查看仅开通企业会员套餐的用户使用,请开通企业会员套餐再查看！':
    'The view of employee details is only available to enterprise VIP package users. Please check it after opening the enterprise VIP package.',
  '客户在线洽谈功能仅开通企业会员套餐的用户使用,请开通企业会员套餐再查看！':
    'Client online chat function is only available to enterprise VIP package users. Please check it after opening the enterprise VIP package.',
  '添加手机号码/邮箱': 'Add Phone Number/Email',
  基础版: 'Starter Version',
  标准版: 'Standard Version',
  升级版: 'Upgrade Version',
  旗舰版: 'Deluxe Version',
  尊享版: 'VIP Version',
  免费注册: 'Free Registration',
  当前的套餐: 'Current package',
  升级为: 'Upgrade to',
  云展系统: 'Cloud Exhibition System',
  全球即时洽谈: 'Global Real-time Chat',
  智能名片: 'Smart Business Cards',
  智能名片500张: '500 Smart Business Cards',
  智能名片5万张: '50,000 Smart Business Cards',
  智能名片10万张: '100,000 Smart Business Cards',
  智能名片25万张: '250,000 Smart Business Cards',
  智能名片150万张: '1.5 million Smart Business Cards',
  员工账号30个: '30 Employee Accounts',
  员工账号100个: '100 Employee Accounts',
  员工账号500个: '500 Employee Accounts',
  员工账号1000个: '1000 Employee Accounts',
  员工账号2000个: '2000 Employee Accounts',
  招标查询100次: '100 Tender Inquiries',
  精准邀约100家: '100 precise invitations',
  商机提醒100家: '100 business opportunities reminded',
  招标查询1000次: '1000 Tender Inquiries',
  招标查询500次: '500 Tender Inquiries',
  招标查询3000次: '3000 Tender Inquiries',
  招标查询1万次: '10,000 Tender Inquiries',
  招标查询6万次: '60,000 Tender Inquiries',
  精准邀约1万家: 'Accurately invited about 10,000 Enterprises',
  精准邀约3万家: 'Accurately invited about 30,000 Enterprises',
  精准邀约12万家: 'Accurately invited about 120,000 Enterprises',
  精准邀约30万家: 'Accurately invited about 300,000 Enterprises',
  商机提醒: 'Business Information Remind',
  商机提醒1000条: '1000 Business Information Reminds',
  商机提醒5000条: '5000 Business Information Reminds',
  商机提醒2万条: '20,000 Business Information Reminds',
  商机提醒10万条: '100,000 Business Information Reminds',
  产品3D扫描1件: '1 3D product scan',
  产品3D扫描3件: '3 3D product scan',
  产品3D扫描5件: '5 3D product scan',
  室内3D扫描3个: '3 3D indoor scans',
  室内3D扫描5个: '5 3D indoor scans',
  '3D航拍扫描1个': '1 3D aerial scan',
  限时优惠: 'Limited-time Offer ',
  线索推送: 'Potential Client Recommend',

  云端完整构筑企业全貌Tip1:
    '3D visualization tools for building a digital factory<br/>Build an all-round enterprise display system by virtual showroom',
  云端完整构筑企业全貌Tip2: 'Virtual Factory Tour<br/>720°Product Photos help you acquire more enterprise information',
  云端完整构筑企业全貌Tip3:
    'Facilitate the digital transformation and upgrading of enterprises, and achieve the efficiency and cost reduction management.',
  全球客户畅聊无障碍Tip1: 'Supporting multi-language 1V1 real-time calling and video chat',
  全球客户畅聊无障碍Tip2: 'Covering most areas of the world to realize real-time message delivery.',
  全球客户畅聊无障碍Tip3:
    'Support sending texts, pictures, emojis, audios and videos, locations, attachments etc., and history message records can be roaming.',
  智能名片TIP1: 'Personalized smart business card to create an exclusive IP image',
  智能名片TIP2: 'All-round display companies and personal information,<br/> Support texts, pictures, videos and etc.',
  智能名片TIP3:
    'Helping clients better understand employees, enterprises, and products to improve client trust and make marketing more efficient.',
  数据引擎高效获客Tip1: 'Gathering hundreds of millions of online and offline client resources',
  数据引擎高效获客Tip2: 'Cloud computing will integrate, filter, classify and analyze enterprise information. ',
  数据引擎高效获客Tip3: 'Custom invitation content can be sent through one key',
  精准商机匹配Tip1: 'Accurate user classification: divided into groups by analyzing client needs in various aspects.',
  精准商机匹配Tip2:
    'Personalized smart analysis: accurately recommend the content that users are interested in according to their personalized labels.',
  精准商机匹配Tip3: 'Accurately push business opportunities: intelligent matching between suppliers and buyers.',
  商机提醒Tip1: 'New information of business opportunities will be reminded by SMS or email.',
  商机提醒Tip2: 'Establish a platform for quick-communication to meet client needs and gain more clients.',
  商机提醒Tip3: 'Improve client service satisfaction and create marketing value.',

  云端完整构筑企业全貌: 'Build a Virtual Factory Panorama',
  企业子账号数: 'Enterprise Sub-Accounts',
  立即邀请: 'Invite Now',
  '还没有同事？立即邀请同事立刻加入公司,共创辉煌！':
    'No colleagues yet? Invite colleagues now to join the company, and create a shining future!',
  子账户已获取的客户数: 'Sub-accounts have acquired clients',

  全球客户畅聊无障碍: 'Accessibility for global clients to chat',

  '智能名片,连接十亿用户': 'Connect billion users by smart business card ',

  数据引擎高效获客: 'Big data facilitates efficient client acquisition',

  精准商机匹配: 'Accurate Matched Business Opportunities',

  '千万商机0延误,0遗漏': 'Won’t miss any business opportunities',

  点击了解更多权益: 'Learn More',
  客服电话: 'Client Service Hotline',
  '搜索未来商机,抢占获客先机': 'Seize the business opportunity to gain more clients',
  '100000+企业正在使用云展动力获客': '100000+ enterprises are using the Cloud Exhibition to gain more clients.',
  '企业会员套餐需要企业主账号开通,子账号无权开通！请联系您的企业管理员进行续费或升级,您的企业管理员为':
    'Enterprise VIP package is only available to enterprise account. Please contact the enterprise account you are affiliated with for renewal or upgrade. Your enterprise account is',
  '您已申请企业认证,正在审核中': 'You have applied for enterprise certification, please wait for check.',
  '免费查阅招标信息条数已用光,若想查看更多招标信息,请升级企业会员套餐!':
    'Your free access to tendering information has run out, please upgrade to VIP package to check more information.',
  预览云展系统: 'Preview Cloud Exhibition System',
  基础版升级提示:
    'Your current corporate membership package is [Basic Edition], and you can generate up to 1 sub-account. If you want to generate more sub-accounts, you can upgrade the corporate membership package',
  商务版升级提示:
    'Your current corporate membership package is [Business Edition], and you can generate up to 5 sub-accounts. If you want to generate more sub-accounts, you can upgrade the corporate membership package',
  旗舰版升级提示:
    'Your current corporate membership package is [Flagship Edition], and you can generate up to 10 sub-accounts. If you want to generate more sub-accounts, you can upgrade the corporate membership package',
  元宇宙版升级提示:
    'Your current corporate membership package is [Metaverse Edition], and you can generate up to 100 sub-accounts. If you need to add sub-accounts, please contact customer service for consultation!',
  '平台冻结,指的是企业已购买的企业会员套餐有效期已过,不再续费或开通了更低的企业会员套餐,超过企业会员套餐内的子账号数量的部分子账号会自动被平台冻结,您可升级更高的企业会员套餐进行解冻':
    'If you don‘t renew your purchased membership package or open a lower enterprise membership package after expiration, the employee accounts that exceed the number of the package will be automatically blocked. You can renew or upgrade to a higher enterprise membership package for unfreezing.',
  资料审核中: 'Reviewing',
  已为您匹配潜在参展商: 'We have found your potential buyers',
  企业中心: 'Enterprise Center',
  完善企业资料: 'Complete the enterprise information',
  升级套餐: 'Upgrade the Package',
  为您的企业选择最佳获客方案: 'Choose the Best Client Access Solution',
  '您好！您现在的身份为个人用户,无法享受企业服务,请申请认证！':
    'Hello! You are currently a personal user, you cannot enjoy enterprise services, please apply for certification!',
  尊享: 'Enjoy',
  项权益: 'Rights',
  当前套餐: 'The current level',
  获客利器: 'Powerful Tool for Client Access',
  我的企业管理: 'Enterprise Management',
  发短信: 'Sending Massage',
  猜您喜欢的云上展览: 'Exhibition you may be interested in.',
  猜您喜欢的云产品: 'Products you may be interested in.',
  '主账号(企业管理者)': 'Enterprise Account (Enterprise Manager)',
  '(企业管理者)': '(Enterprise Manager)',
  云上展览系统: 'Virtual Exhibitions',
  客户管理系统: 'Client Management',
  财务中心: 'Finance Center',
  企业获客数: 'The Number of Clients',
  员工分享数: 'Employees’ Total Shares',
  客户查看数: 'Clients’ Total Views',
  客户转发数: 'Clients’ Total Reposts',
  客户点赞数: 'Clients’ Total Likes',
  完善: 'Edit',
  Ta感兴趣标签: 'Interested Industry',
  员工营销数据: 'Employee Marketing Data',
  企业通讯录容量: 'Capacity of the contact list',
  员工已使用数量: 'Number of contacts',
  已超过通讯录容量: 'Over the capacity limit',
  云展动力智能获客方案套餐权限服务列表: 'Smart Client Access Plan',
  浏览我的企业: 'Browse my business',
  // upgradevip module
  填写您的企业: 'Enter Your Company',
  购买版本: 'Select Version',
  限时折扣: 'Limited Offer',
  '元/年': 'CNY/Year',
  免费体验: 'Free Trial',
  提交订单: 'Submit Order',
  支付订单: 'Pay Order',
  企业会员套餐: 'Enterprise Membership Package',
  套餐期限: 'Package Duration',
  支付成功起一年: 'One year from the date of successful payment',
  订单金额: 'Order Amount',
  对公转账: 'Bank Transfer',
  微信支付: 'WeChat Pay',
  '实付:': 'Amount Due:',
  '已优惠:': 'Discount:',
  支付即代表您同意: 'By paying, you agree to the',
  '《云展动力VIP会员服务协议》': '"Cloud Exhibition VIP Membership Agreement"',
  进行对公转账: 'Proceed with Bank Transfer',
  提示: 'Notice',
  '该企业已注册, 请确认名称是否正确': 'This company is already registered, please confirm if the name is correct',
  '名字有误, 重新输入': 'Name is incorrect, re-enter',
  '名字正确,联系客服': 'Name is correct, contact support',
  '您有未支付的订单, 是否前往支付?': 'You have an unpaid order, would you like to proceed to payment?',
  查看待支付订单: 'View Unpaid Order',
  取消并创建新订单: 'Cancel and Create New Order',
  '您有待审核的订单, 请等待审核通过后再购买':
    'You have an order pending review, please wait for approval before purchasing',
  请输入企业名称: 'Please enter company name',
  您尚未支付成功: 'Your payment has not been completed',
  // btmInfo and fixedRightCont
  '咨询产品、报价及更多细节？请联系我们': 'Need product information, quotes, or more details? Contact us',
  在线咨询: 'Online Consultation',
  微信咨询: 'WeChat Consultation',
  关注我们: 'Follow Us',
  // firstLogin module
  加入已有企业: 'Join Existing Company',
  您的姓名: 'Your Name',
  企业名称: 'Company Name',
  企业地址: 'Company Address',
  修改企业名称: 'Edit Company Name',
  提交: 'Submit',
  '有疑问? 联系客服': 'Have questions? Contact support',
  请输入姓名: 'Please enter your name',
  创建: 'Create',
  创建成功: 'Created successfully',
  // order module
  全部订单: 'All Orders',
  待支付: 'Pending Payment',
  审核中: 'Under Review',
  已完成: 'Completed',
  商品信息: 'Product Info',
  订单类型: 'Order Type',
  订单状态: 'Order Status',
  操作: 'Actions',
  '订单号:': 'Order No.:',
  立即付款: 'Pay Now',
  去转账: 'Transfer',
  取消订单: 'Cancel Order',
  重新下单: 'Reorder',
  申请合同: 'Apply for Contract',
  查看合同: 'View Contract',
  申请发票: 'Apply for Invoice',
  取消成功: 'Cancelled successfully',
  立即支付: 'Pay Immediately',
  联系客服: 'Contact Support',
  已完成转账: 'Transfer Completed',
  // wechatPayModal
  距离二维码过期还剩: 'QR code expires in',
  二维码已过期请刷新: 'QR code expired, please refresh',
  刷新: 'Refresh',
  使用微信扫码支付: 'Scan with WeChat to pay',
}
